
import {Component, Vue, Watch} from 'vue-property-decorator';
import ReportFilters from "@/modules/Report/components/ReportFilters.vue";
import ReportTableMovements from "@/modules/Report/Movements/components/ReportTableMovements.vue";
import ReportTableBalance from "@/modules/Report/components/tables/ReportTableBalance.vue";
import ReportTableEvents from "@/modules/Report/components/events/ReportTableEvents.vue";
import AppPageHeader from "@/components/AppPageHeader.vue";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import ReportTableCars from "@/modules/Report/components/tables/ReportTableCars.vue";
import ReportTableCarsBalance from "@/modules/Report/components/tables/ReportTableCarsBalance.vue";
import _ from "lodash";
import ReportTableParks from "@/modules/Report/components/tables/ReportTableParks.vue";
import ReportTableAgent from "@/modules/Report/components/tables/ReportTableAgent.vue";
import {IBook} from "@/interfaces/book.interface";
import SelectMovementPopup from "@/modules/Report/Movements/components/specialComponents/SelectMovementPopup.vue";
import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";

@Component({
  components: {
    SelectMovementPopup,
    AppPageHeader,
    ReportFilters,
    ReportTableBalance,
    ReportTableMovements,
    ReportTableEvents,
    ReportTableCars,
    ReportTableCarsBalance,
    ReportTableParks,
    ReportTableAgent
  },
})
export default class Report extends Vue {
  $refs: any;
  isLoading: boolean = true;
  reportName = IReport.ReportName;

  get activeReport() { return this.$store.state.report.activeReport; }
  get tableList(): IReport.ReportType { return this.$store.getters['report/sortedList']; }
  get displayDetails() { return this.$store.state.report.displayDetails; }
  get tableTotal(): IReport.ITableTotal { return this.$store.state.report.tableTotal; }
  get parksBook(): IBook.ParkBookItem[] { return this.$store.getters['book/parksBook']; }
  get dialogs(): IDialogStoreState { return this.$store.state.dialog; }
  get reportInfo() {
    const reportTitle = IReport.ReportTitle;
    const reportName = IReport.ReportName;
    let reports = {
      [IReport.ReportName.Movement]:    { title: reportTitle[reportName.Movement],    component: 'ReportTableMovements', },
      [IReport.ReportName.Balance]:     { title: reportTitle[reportName.Balance],     component: 'ReportTableBalance', },
      [IReport.ReportName.Events]:      { title: reportTitle[reportName.Events],      component: 'ReportTableEvents', },
      [IReport.ReportName.Cars]:        { title: reportTitle[reportName.Cars],        component: 'ReportTableCars', },
      [IReport.ReportName.CarsBalance]: { title: reportTitle[reportName.CarsBalance], component: 'ReportTableCarsBalance', },
      [IReport.ReportName.Parks]:       { title: reportTitle[reportName.Parks],       component: 'ReportTableParks', },
      [IReport.ReportName.Agent]:       { title: reportTitle[reportName.Agent],       component: 'ReportTableAgent', },
    };
    return reports[this.activeReport];
  }
  get routeBack() {
    let routeBack = {
      label: IReport.ReportTitle[this.$store.state.report.previousReport.name],
      action: this.openAllList,
    };
    return this.displayDetails ? routeBack : null;
  }
  get appTableV2() {
    // let storageValue = localStorage.getItem(IApp.LocalStorageKeys.AppTableV2);
    // return storageValue ? JSON.parse(storageValue) : false;
    return [this.reportName.Movement].includes(this.activeReport);
  }

  async created() {
    try {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');
      await this.openReport(this.$route.meta.command, true);
      this.isLoading = false;
    }
    catch (error) { await this.$store.dispatch('handleError', error) }
  }

  async openReport(report: IReport.ReportName, needFilters = false) {
    this.$store.commit('report/setProperty', { name: 'filters', value: _.cloneDeep(IReport.DefaultFilters) });
    let payload: any = { reportName: report };
    if (needFilters) {
      if (this.$route.params && this.$route.params.filters) {
        payload.filters = Object.assign({}, IReport.DefaultFilters, this.$route.params.filters);
      }
      else {
        let storageForm = localStorage.getItem(IReport.LocalStorageKeys.ReportFilters);
        let presetFilters = !!storageForm ? JSON.parse(storageForm) : null;
        if (presetFilters && presetFilters[report]) {
          payload.filters = {...presetFilters[report]};
        }
      }
    }

    if (this.parksBook.length === 1) {
      payload.filters = { ...payload.filters, parks: [this.parksBook[0].id], };
    }

    await this.$store.dispatch('report/getReport', payload);
  }

  downloadExcel() {
    let params: any = this.$refs[this.reportInfo.component].prepareExcel();
    this.tableToExcel(params.table, params.tableName, params.fileName);
  }

  tableToExcel(table, name, fileName) {
    let uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) {
      return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; })
    };
    let downloadURI = function(uri, name) {
      let link = document.createElement("a");
      link.download = name;
      link.href = uri;
      link.click();
    };

    let ctx = {worksheet: name || 'Worksheet', table: table};
    let resuri = uri + base64(format(template, ctx));
    downloadURI(resuri, fileName);
  }

  printTable() {
    this.$refs[this.reportInfo.component].printTable();
  }

  async openAllList() {
    this.$store.commit('report/setProperty', { name: 'filters', value: this.$store.state.report.defaultFilters });
    this.$store.commit('report/setProperty', { name: 'defaultFilters', value: _.cloneDeep(IReport.DefaultFilters) });

    this.$store.commit('report/setProperty', { name: 'displayDetails', value: false });

    this.$store.commit('report/setProperty', { name: 'report', value: this.$store.state.report.previousReport.list });
    this.$store.commit('report/setProperty', { name: 'activeReport', value: this.$store.state.report.previousReport.name });
    this.$store.commit('report/setProperty', { name: 'previousReport', value: { name: null, list: [], }});
  }

  @Watch('$route')
  async onIsVisitedStoreInitChange() {
    this.isLoading = true;
    await this.openReport(this.$route.meta.command, true);
    await this.$store.dispatch('book/getBook', {
      bookNames: [IBook.TableName.groupTypes],
      needUpdate: true,
      reportName: this.$route.meta.command,
    });

    this.isLoading = false;
  }
}
